import { Link } from "react-router-dom";
import { TruncateWithTooltip } from "shared/components/TruncateWithTooltip";

interface LinkableTextProps {
  content?: string;
  linkTo?: string;
}

export const LinkableText = ({ content, linkTo }: LinkableTextProps) => {
  if (!content)
    return (
      <span className="text-sm font-medium text-content-1000 flex-1">-</span>
    );

  if (!linkTo)
    return (
      <TruncateWithTooltip
        content={content}
        className="text-sm font-medium text-content-1000 flex-1"
        tooltipClassName="z-[102] break-words whitespace-normal"
        placement="bottom"
      />
    );

  return (
    <Link to={linkTo} className="flex-1 min-w-0 block">
      <TruncateWithTooltip
        content={content}
        className="text-sm font-medium text-content-1000 hover:underline cursor-pointer"
        tooltipClassName="z-[102] break-words whitespace-normal"
        placement="bottom"
      />
    </Link>
  );
};
